
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#303c42"}},[_c('path',{attrs:{"d":"M16.5 8h.15a.55.55 0 00.51-.5.5.5 0 00-.09-.29C15.92 4.09 12.59 2 8.75 2 3.93 2 0 5.36 0 9.5a7.06 7.06 0 003.09 5.71l-1 2.07a.5.5 0 00.7.66l2.65-1.51a10 10 0 002.22.51.5.5 0 00.54-.61A5.8 5.8 0 018 15c0-3.86 3.81-7 8.5-7zM11 6a1 1 0 11-1 1 1 1 0 011-1zM6 8a1 1 0 111-1 1 1 0 01-1 1z"}}),_c('path',{attrs:{"d":"M24 15c0-3.31-3.36-6-7.5-6S9 11.69 9 15s3.36 6 7.5 6a9.23 9.23 0 002.3-.29l2.48 1.24a.5.5 0 00.22.05.5.5 0 00.46-.69l-.68-1.7A5.64 5.64 0 0024 15zm-10-1a1 1 0 111-1 1 1 0 01-1 1zm5 0a1 1 0 111-1 1 1 0 01-1 1z"}})])])
          )
        }
      }
    